import { render, staticRenderFns } from "./When.vue?vue&type=template&id=060481ec&scoped=true"
import script from "./When.vue?vue&type=script&lang=js"
export * from "./When.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060481ec",
  null
  
)

export default component.exports